import { Component, Emit, Vue } from 'vue-property-decorator'

@Component
export default class LoginLayoutRecoveryEmailSent extends Vue {
    @Emit('show-login')
    showLogin(): void {}

    @Emit('show-recovery')
    showRecovery(): void {}
}
